import { http } from "@/lib/http";
export function fetchReminders() {
  return http.get("/api/reminders/get_all").then((res) => res.data);
}
export function fetchReminder(id) {
  return http
    .post("/api/reminders/get/mid", { mid: id })
    .then((res) => res.data);
}
export function addReminder(payload) {
  return http.post("/api/reminders/add", payload).then((res) => res.data);
}
export function editReminder(payload) {
  return http.post("/api/reminders/edit", payload).then((res) => res.data);
}
export function deleteReminder(id) {
  return http.delete(`/api/reminders/delete/${id}`).then((res) => res.data);
}
export function fetchTopics() {
  return http.get("/api/topics/get_all").then((res) => res.data);
}
export function uploadReminderFile(file) {
  const data = new FormData();
  let url;
  if (file.type.includes("image")) {
    url = "/api/image_upload/messages";
    data.append("imageFile", file);
  } else if (file.type.includes("video")) {
    url = "/api/video_upload/messages";
    data.append("videoFile", file);
  } else {
    url = "/api/file_upload/messages";
    data.append("file", file);
  }
  return http
    .post(url, data, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.imageUrl);
}
